import { render, staticRenderFns } from "./business_order.vue?vue&type=template&id=3c82f2e7&scoped=true"
import script from "./business_order.vue?vue&type=script&lang=ts"
export * from "./business_order.vue?vue&type=script&lang=ts"
import style0 from "./business_order.vue?vue&type=style&index=0&id=3c82f2e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82f2e7",
  null
  
)

export default component.exports